import Swiper from 'swiper';

document.addEventListener(
    'DOMContentLoaded',
    () => {
        const categorySections = document.querySelectorAll(
            '.js-category-section',
        );

        categorySections.forEach((categorySection) => {
            let slideIndex = 0;

            const categorySectionList = categorySection.querySelector(
                '.js-category-section__list',
            );

            const categorySectionButtons = categorySection?.querySelectorAll(
                '.js-category-section__button',
            );
            const categorySectionContents = categorySection?.querySelectorAll(
                '.js-category-section__content',
            );
            const categorySectionContacts = categorySection?.querySelectorAll(
                '.js-category-section__contact',
            );

            const setInitialSlide = () => {
                categorySectionButtons?.forEach(
                    (categorySectionButton, categorySectionButtonIndex) => {
                        if (
                            categorySectionButton.classList.contains('active')
                        ) {
                            slideIndex = categorySectionButtonIndex;
                            if (categorySectionContents) {
                                categorySectionContents.forEach(
                                    (categorySectionContent, index) => {
                                        if (
                                            categorySectionContent.dataset
                                                .categoryName ==
                                            categorySectionButton.dataset
                                                .categoryName
                                        ) {
                                            categorySectionContent.classList.add(
                                                'category-section__content--active',
                                            );
                                            categorySectionContacts[
                                                index
                                            ].classList.add('active');
                                        } else {
                                            categorySectionContent.classList.remove(
                                                'category-section__content--active',
                                            );
                                            categorySectionContacts[
                                                index
                                            ].classList.remove('active');
                                        }
                                    },
                                );
                            }
                        }
                    },
                );
            };

            setInitialSlide();

            const swiperSlder = new Swiper(categorySectionList, {
                initialSlide: slideIndex,
                slidesPerView: 'auto',
                spaceBetween: 10,
                speed: 300,
                loop: false,
                grabCursor: true,
            });

            categorySectionButtons.forEach(
                (categorySectionButton, categorySectionButtonIndex) => {
                    categorySectionButton.addEventListener('click', (event) => {
                        const ymap = document.querySelector('.js-ymap');
                        ymap?.dispatchEvent(
                            new CustomEvent('setTab', {
                                detail: categorySectionButtonIndex,
                            }),
                        );

                        categorySectionButtons.forEach(
                            (categorySectionButton) => {
                                if (
                                    categorySectionButton ==
                                    event.target.closest(
                                        '.js-category-section__button',
                                    )
                                ) {
                                    categorySectionButton.classList.add(
                                        'active',
                                    );
                                } else {
                                    categorySectionButton.classList.remove(
                                        'active',
                                    );
                                }
                            },
                        );
                        setInitialSlide();
                        swiperSlder.slideTo(categorySectionButtonIndex);
                    });
                },
            );
        });
    },
    { once: true },
);
